import script from "./SignalQueue.vue?vue&type=script&setup=true&lang=js"
export * from "./SignalQueue.vue?vue&type=script&setup=true&lang=js"

import "./SignalQueue.vue?vue&type=style&index=0&id=31fac97c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31fac97c"]])

export default __exports__